// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__TbD9-","title":"Terms_title__+c6g6","text":"Terms_text__tQRzP"};